var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.msg)?_c('div',{staticClass:"alert alert-error",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.error_msg)+" ")]):_vm._e(),_c('div',{attrs:{"id":"paypal-button-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }